import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { ADD_MESSAGE_TEMPLATE_PATH, TABLET } from '@app/constants';
import { useWindowSize } from '@app/hooks';

import type { FC } from 'react';

export const MessageTemplatesHeader: FC = () => {
  const { innerWidth } = useWindowSize();

  const label = innerWidth < TABLET ? '' : 'Добавить шаблон';

  return (
    <Link to={ADD_MESSAGE_TEMPLATE_PATH}>
      <Button type="primary" icon={<PlusOutlined />} data-testid="add-template">
        {label}
      </Button>
    </Link>
  );
};
